import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FiLock, FiMail, FiArrowLeft, FiUserPlus, FiEye, FiEyeOff, FiRefreshCw } from 'react-icons/fi';
import { useAuth } from '../utils/auth';
import { ensureValidTenantId } from '../utils/auth';
import Modal from '../components/Modals/Modal';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [step, setStep] = useState(1); // 1: Login
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [errors, setErrors] = useState({});
  const [loginError, setLoginError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  // Remove all OTP-related state
  // const [otp, setOtp] = useState('');
  // const [otpError, setOtpError] = useState('');
  // const [otpSent, setOtpSent] = useState(false);
  // const [resendDisabled, setResendDisabled] = useState(false);
  // const [resendCountdown, setResendCountdown] = useState(0);
  // const [pendingLoginData, setPendingLoginData] = useState(null);
  // const [showOtpModal, setShowOtpModal] = useState(false);
  // const [demoOtp, setDemoOtp] = useState('');

  // Removed tenantId redirect useEffect

  // Remove all OTP-related useEffect
  // useEffect(() => {
  //   // Handle resend countdown
  //   if (resendCountdown > 0) {
  //     const timer = setTimeout(() => {
  //       setResendCountdown(resendCountdown - 1);
  //     }, 1000);
  //     return () => clearTimeout(timer);
  //   } else {
  //     setResendDisabled(false);
  //   }
  // }, [resendCountdown]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
    // Clear login error when user starts typing
    if (loginError) {
      setLoginError('');
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!formData.password) {
      newErrors.password = 'Password is required';
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setLoginError('');
    setIsLoading(true);
    try {
      // Only verify email/password, no account name needed
      const res = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: formData.email,
          password: formData.password
        })
      });
      if (!res.ok) {
        setLoginError('Invalid email or password.');
        return;
      }
      const loginData = await res.json();
      // Store the actual accountId from login response for proper API calls
      localStorage.setItem('tenantId', loginData.accountId);

      // Store trial dates for accurate trial timer
      if (loginData.trialStartDate) {
        localStorage.setItem('accountCreatedAt', loginData.trialStartDate);
      }
      if (loginData.trialEndDate) {
        localStorage.setItem('trialEndDate', loginData.trialEndDate);
      }

      login(loginData.access_token, {
        email: formData.email,
        name: formData.email.split('@')[0]
      });

      // Check onboarding status after successful login
      try {
        const onboardingRes = await fetch(`${API_BASE_URL}/api/accounts/onboarding/status`, {
          headers: {
            'Authorization': `Bearer ${loginData.access_token}`
          }
        });

        if (onboardingRes.ok) {
          const isOnboardingCompleted = await onboardingRes.json();
          if (isOnboardingCompleted) {
            navigate('/dashboard');
          } else {
            navigate('/onboarding');
          }
        } else {
          // If we can't check onboarding status, assume it's not completed
          navigate('/onboarding');
        }
      } catch (error) {
        console.error('Error checking onboarding status:', error);
        navigate('/onboarding');
      }
    } catch (err) {
      setLoginError('Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  // Remove all OTP-related functions
  // const handleOtpSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!otp.trim()) {
  //     setOtpError('Please enter the verification code');
  //     return;
  //   }

  //   setIsLoading(true);
  //   setOtpError('');

  //   try {
  //     // Verify OTP
  //     const verifyRes = await fetch(`${API_BASE_URL}/auth/verify-otp`, {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({
  //         email: formData.email,
  //         otp: otp
  //       })
  //     });

  //     if (!verifyRes.ok) {
  //       setOtpError('Invalid verification code. Please try again.');
  //       return;
  //     }

  //     // Complete login after OTP verification
  //     if (pendingLoginData) {
  //       login(pendingLoginData.access_token, {
  //         email: pendingLoginData.email,
  //         name: pendingLoginData.name
  //       });
  //       navigate('/dashboard');
  //     }

  //   } catch (err) {
  //     setOtpError('Verification failed. Please try again.');
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // const handleResendOTP = async () => {
  //   setResendDisabled(true);
  //   setResendCountdown(60);
  //   setOtpError('');

  //   try {
  //     const resendRes = await fetch(`${API_BASE_URL}/auth/send-otp`, {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({
  //         email: formData.email
  //       })
  //     });

  //     if (!resendRes.ok) {
  //       setOtpError('Failed to resend verification code. Please try again.');
  //     } else {
  //       const otpData = await resendRes.json();
  //       if (otpData.demoOtp) {
  //         setDemoOtp(otpData.demoOtp);
  //         setShowOtpModal(true);
  //       }
  //       setOtpError('Verification code resent successfully!');
  //       setTimeout(() => setOtpError(''), 3000);
  //     }
  //   } catch (err) {
  //     setOtpError('Failed to resend verification code. Please try again.');
  //   }
  // };

  const handleBackToTenant = () => {
    localStorage.removeItem('tenantId');
    navigate('/');
  };

  // Remove all OTP-related UI
  // if (step === 2) {
  //   return (
  //     <div className="auth-container">
  //       <div className="auth-card">
  //         <button 
  //           onClick={handleBackToLogin}
  //           className="back-button"
  //           type="button"
  //         >
  //           <FiArrowLeft /> Back to Login
  //         </button>

  //         <div className="auth-header">
  //           <div className="brand-logo">
  //             <h2>Hamara Bill</h2>
  //             <p className="brand-subtitle">By TFS Traders</p>
  //           </div>
  //           <h1>Two-Factor Authentication</h1>
  //           <p className="text-muted">Enter the verification code sent to your email</p>
  //           <div className="account-info">
  //             <p><strong>Email:</strong> {formData.email}</p>
  //           </div>
  //         </div>

  //         <form onSubmit={handleOtpSubmit} className="auth-form">
  //           <div className="form-group">
  //             <label className="form-label">Verification Code</label>
  //             <input
  //               type="text"
  //               className="form-input"
  //               placeholder="Enter 6-digit code"
  //               value={otp}
  //               onChange={(e) => {
  //                 setOtp(e.target.value);
  //                 setOtpError('');
  //               }}
  //               maxLength={6}
  //               disabled={isLoading}
  //             />
  //             {otpError && <span className="error-message">{otpError}</span>}
  //           </div>

  //           <button 
  //             type="submit" 
  //             className={`btn btn-primary btn-block ${isLoading ? 'loading' : ''}`}
  //             disabled={isLoading}
  //           >
  //             {isLoading ? 'Verifying...' : 'Verify & Sign In'}
  //           </button>

  //           <div className="resend-section">
  //             <p className="text-center text-muted">
  //               Didn't receive the code? 
  //               <button 
  //                 type="button" 
  //                 className="link-primary resend-btn"
  //                 onClick={handleResendOTP}
  //                 disabled={resendDisabled || isLoading}
  //               >
  //                 {resendDisabled 
  //                   ? `Resend in ${resendCountdown}s` 
  //                   : 'Resend Code'
  //                 }
  //               </button>
  //             </p>
  //           </div>
  //         </form>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="auth-container">
      <div className="auth-card">
        {/* Back Button */}
        <button
          onClick={handleBackToTenant}
          className="back-button"
          type="button"
        >
          <FiArrowLeft /> Back to Account Selection
        </button>
        <div className="auth-header">
          <div className="brand-logo">
            <h2>Hamara Bill</h2>
            <p className="brand-subtitle">By TFS Traders</p>
          </div>
          <h1>Welcome Back</h1>
          <p className="text-muted">Sign in to continue to Bill Book</p>
        </div>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <div className="input-group">
              <FiMail className="input-icon" />
              <input
                type="email"
                name="email"
                className={`form-input ${errors.email ? 'error' : ''}`}
                placeholder="Enter your mail"
                value={formData.email}
                onChange={handleChange}
                disabled={isLoading}
              />
            </div>
            {errors.email && <span className="error-message">{errors.email}</span>}
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <div className="input-group">
              <FiLock className="input-icon" />
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                className={`form-input ${errors.password ? 'error' : ''}`}
                placeholder="Enter Your Password"
                value={formData.password}
                onChange={handleChange}
                disabled={isLoading}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                disabled={isLoading}
                tabIndex={-1}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
            {errors.password && <span className="error-message">{errors.password}</span>}
          </div>
          {loginError && (
            <div className="login-error-container">
              <span className="error-message">{loginError}</span>
            </div>
          )}
          <div className="form-group">
            <div className="flex-between">
              <label className="checkbox-label">
                <input type="checkbox" /> Remember me
              </label>
              <Link to="/forgot-password" className="forgot-password">Forgot Password?</Link>
            </div>
          </div>
          <button
            type="submit"
            className={`btn btn-primary btn-block ${isLoading ? 'loading' : ''}`}
            disabled={isLoading}
          >
            {isLoading ? 'Signing In...' : 'Sign In'}
          </button>
          <div className="form-group">
            <p className="text-center text-muted">
              Don't have an account? <Link to="/register" className="link-primary">Sign Up</Link>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;